import { render, staticRenderFns } from "./TqPickColor.vue?vue&type=template&id=8ab1e758&scoped=true&"
import script from "./TqPickColor.vue?vue&type=script&lang=js&"
export * from "./TqPickColor.vue?vue&type=script&lang=js&"
import style0 from "./TqPickColor.vue?vue&type=style&index=0&id=8ab1e758&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab1e758",
  null
  
)

export default component.exports